export default {
  title: 'ADM users',
  tableHeaders: {
    id: 'id',
    username: 'username',
    created: 'created',
  },
  filters: {
    create: 'New ADM user',
    search: 'Search for',
  },
  modal: {
    create: 'New ADM user',
    edit: 'Edit User: {{username}}',
    save: 'Save',
    cancel: 'Cancel',
    form: {
      addChoice: 'Add Choice',
      choices: 'Choices *',
      fields: {
        email: 'Email',
        confirmPassword: {
          placeholder: 'Complete Input',
          label: 'Confirm Password',
        },
        password: {
          placeholder: 'Complete Input',
          label: 'Password',
        },
        username: 'Username',
        surname: 'Surname',
        firstname: 'First Name',
        title: 'Title',
      },
    },
  },
};
